export default function RemoveSpaceAndDot(val: string) {
  const regex = /(\d)\s|\.+(?=\d)/g;
  const subst = `$1`;
  const result = val.replace(regex, subst);

  return result;
}
